<template>
  <div>
    <modal
      name="respostaModal"
      height="auto"
      width="55%"
      :scrollable="true"
      :clickToClose="true"
    >
      <CloseModal :close="close" />
      <div class="modalbox">
        <div class="modalbox-content">
          <CTabs variant="tabs" class="nav-tabs-boxed">
            <CTab :title="`Respostas do formulário ${formulario.formularioId}`">
              <div
                class="xrow"
                v-for="(pergunta, index) in perguntas"
                :key="index"
              >
                <div class="col-1-1">
                  <div class="form-group">
                    <label style="font-size: 1rem">{{
                      pergunta.descricao
                    }}</label>
                    <RespostaViewBase
                      :tipo="pergunta.tipo"
                      :alternativas="pergunta.alternativas"
                      :respostaTexto="pergunta"
                    />
                    <br />
                  </div>
                </div>
              </div>

              <div class="xrow edit-buttons">
                <el-dropdown @command="baixarArquivo" class="pull-right">
                  <el-button type="primary">
                    Baixar <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="JSON">JSON</el-dropdown-item>
                    <el-dropdown-item command="XML">XML</el-dropdown-item>
                    <el-dropdown-item command="PDF">PDF</el-dropdown-item>
                    <el-dropdown-item command="CSV">CSV</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </CTab>
          </CTabs>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import CloseModal from "@/components/CloseModal.vue";
import { postBlob } from "@/helpers/apiRequest";
import RespostaViewBase from "./RespostaViewBase.vue";

export default {
  name: "RespostaBase",
  components: {
    CloseModal,
    RespostaViewBase,
  },
  props: {
    formulario: {
      type: Object,
      default: () => ({}),
    },
    perguntas: { type: Array, required: true },
    close: { type: Function, required: true },
  },
  methods: {
    async baixarArquivo(tipo) {
      try {
        const response = await postBlob(
          `/admin/formularios/pergunta/respostas/download?tipoArquivo=${tipo}&chave=${this.formulario.chave}`
        );

        const blob = await response.blob();

        const contentDisposition = response.headers.get("Content-Disposition");
        const filename =
          contentDisposition?.split("filename=")[1]?.replace(/"/g, "") ||
          `arquivo.${tipo.toLowerCase()}`;

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error(error);
        this.$message?.error("Falha ao baixar o arquivo");
      }
    },
  },
};
</script>
